// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { defer } from 'rxjs';
import { map } from 'rxjs/operators';
import { archiveFieldSchemaRequestToJson, createFieldSchemaRequestToJson, createFieldSchemaResponseFromJson, getMultiFieldSchemaRequestToJson, getMultiFieldSchemaResponseFromJson, listFieldSchemaRequestToJson, listFieldSchemaResponseFromJson, unarchiveFieldSchemaRequestToJson, updateFieldSchemaRequestToJson } from './codec';
import { fetchRpc } from '@vendasta/protos/fetch-transport';
import { getGlobalTransport } from '@vendasta/protos/transport';
export async function createFieldSchema(request) {
    const raw = await fetchRpc('crm.v1.CRMFieldSchemaService/CreateFieldSchema', createFieldSchemaRequestToJson(request));
    return createFieldSchemaResponseFromJson(raw);
}
export function createFieldSchema$(request, options) {
    return defer(() => createFieldSchemaWithTransport$(getGlobalTransport(), request, options));
}
export function createFieldSchemaWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMFieldSchemaService/CreateFieldSchema', createFieldSchemaRequestToJson(request), options)
        .pipe(map(resp => createFieldSchemaResponseFromJson(resp)));
}
export async function getMultiFieldSchema(request) {
    const raw = await fetchRpc('crm.v1.CRMFieldSchemaService/GetMultiFieldSchema', getMultiFieldSchemaRequestToJson(request));
    return getMultiFieldSchemaResponseFromJson(raw);
}
export function getMultiFieldSchema$(request, options) {
    return defer(() => getMultiFieldSchemaWithTransport$(getGlobalTransport(), request, options));
}
export function getMultiFieldSchemaWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMFieldSchemaService/GetMultiFieldSchema', getMultiFieldSchemaRequestToJson(request), options)
        .pipe(map(resp => getMultiFieldSchemaResponseFromJson(resp)));
}
export async function listFieldSchema(request) {
    const raw = await fetchRpc('crm.v1.CRMFieldSchemaService/ListFieldSchema', listFieldSchemaRequestToJson(request));
    return listFieldSchemaResponseFromJson(raw);
}
export function listFieldSchema$(request, options) {
    return defer(() => listFieldSchemaWithTransport$(getGlobalTransport(), request, options));
}
export function listFieldSchemaWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMFieldSchemaService/ListFieldSchema', listFieldSchemaRequestToJson(request), options)
        .pipe(map(resp => listFieldSchemaResponseFromJson(resp)));
}
export async function updateFieldSchema(request) {
    await fetchRpc('crm.v1.CRMFieldSchemaService/UpdateFieldSchema', updateFieldSchemaRequestToJson(request));
}
export function updateFieldSchema$(request, options) {
    return defer(() => updateFieldSchemaWithTransport$(getGlobalTransport(), request, options));
}
export function updateFieldSchemaWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMFieldSchemaService/UpdateFieldSchema', updateFieldSchemaRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function archiveFieldSchema(request) {
    await fetchRpc('crm.v1.CRMFieldSchemaService/ArchiveFieldSchema', archiveFieldSchemaRequestToJson(request));
}
export function archiveFieldSchema$(request, options) {
    return defer(() => archiveFieldSchemaWithTransport$(getGlobalTransport(), request, options));
}
export function archiveFieldSchemaWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMFieldSchemaService/ArchiveFieldSchema', archiveFieldSchemaRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function unarchiveFieldSchema(request) {
    await fetchRpc('crm.v1.CRMFieldSchemaService/UnarchiveFieldSchema', unarchiveFieldSchemaRequestToJson(request));
}
export function unarchiveFieldSchema$(request, options) {
    return defer(() => unarchiveFieldSchemaWithTransport$(getGlobalTransport(), request, options));
}
export function unarchiveFieldSchemaWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMFieldSchemaService/UnarchiveFieldSchema', unarchiveFieldSchemaRequestToJson(request), options)
        .pipe(map(() => undefined));
}
